module.exports = __webpack_public_path__ + "static/stegosaurus-24df21370fd0662dc98d1b4d6e7d2bc1.jpeg";